import { jsx as _jsx } from "react/jsx-runtime";
import colors from "@colors/colors";
import constants from "@utils/constants";
import { FaWhatsapp } from "react-icons/fa";
import RoundedButton from "./roundedButton/RoundedButton";
const WhatsAppButton = () => {
    return (_jsx(RoundedButton, { text: "WhatsApp", backgroundColor: colors.whatsAppGreen, textColor: colors.white, iconColor: colors.white, icon: FaWhatsapp, href: constants.whatsappUrl }));
};
export default WhatsAppButton;
